module.exports = __webpack_public_path__ + "img/jan.889260f1.jpg";